import React from "react";
import "./Button.css";
import { ButtonVariant, ButtonSize } from "../../types/common";

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  isLoading?: boolean;
  loadingText?: string;
  children: React.ReactNode;
}

const Button: React.FC<ButtonProps> = ({
  variant = "primary",
  size = "medium",
  isLoading = false,
  loadingText = "Loading...",
  disabled,
  className = "",
  children,
  ...props
}) => {
  const baseClass = "button";
  const variantClass = `button-${variant}`;
  const sizeClass = `button-${size}`;
  const loadingClass = isLoading ? "button-loading" : "";

  const classes = [baseClass, variantClass, sizeClass, loadingClass, className].filter(Boolean).join(" ");

  return (
    <button className={classes} disabled={disabled || isLoading} {...props}>
      {isLoading ? loadingText : children}
    </button>
  );
};

export default Button;
